/* Tipsy: избранное.
   Хранение — localStorage (ключ tipsy:favorites, {v:1, handles:[...]}).
   Слой хранения изолирован — при необходимости сюда позже встраивается
   синхронизация с аккаунтом. Клики ловим делегированием на document,
   поэтому сердечки переживают любые перерисовки DOM (фильтры каталога,
   quick view, предиктивный поиск). Отрисовку состояний повторяем по
   MutationObserver. */
(() => {
  if (window.TipsyFavorites) return; // повторная загрузка скрипта (quick view)

  const KEY = 'tipsy:favorites';
  let memoryFallback = []; // Safari private mode и т.п.

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return memoryFallback.slice();
      const data = JSON.parse(raw);
      if (Array.isArray(data)) return data.filter((h) => typeof h === 'string');
      if (data && Array.isArray(data.handles)) return data.handles.filter((h) => typeof h === 'string');
      return [];
    } catch (e) {
      return memoryFallback.slice();
    }
  }

  function write(handles) {
    memoryFallback = handles.slice();
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: 1, handles: handles }));
    } catch (e) { /* нет localStorage — живём в памяти до перезагрузки */ }
    document.dispatchEvent(new CustomEvent('tipsy:favorites:changed', { detail: { handles: handles } }));
  }

  const api = {
    list() { return read(); },
    has(handle) { return read().indexOf(handle) !== -1; },
    toggle(handle) {
      const handles = read();
      const i = handles.indexOf(handle);
      if (i === -1) handles.push(handle); else handles.splice(i, 1);
      write(handles);
      return i === -1;
    },
    remove(handle) {
      const handles = read().filter((h) => h !== handle);
      write(handles);
    },
  };
  window.TipsyFavorites = api;

  /* ---- отрисовка сердечек и счётчиков ---- */

  function paint() {
    const handles = read();
    document.querySelectorAll('[data-tipsy-fav]').forEach((btn) => {
      const active = handles.indexOf(btn.dataset.tipsyFav) !== -1;
      btn.classList.toggle('tipsy-fav--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      if (label) btn.setAttribute('aria-label', label);
    });
    const count = handles.length;
    document.querySelectorAll('[data-tipsy-fav-count]').forEach((el) => {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tipsy-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    api.toggle(btn.dataset.tipsyFav);
  });

  document.addEventListener('tipsy:favorites:changed', paint);
  window.addEventListener('storage', (e) => { if (e.key === KEY) paint(); });

  let rafId = null;
  const observer = new MutationObserver(() => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => { rafId = null; paint(); });
  });

  function start() {
    paint();
    observer.observe(document.body, { childList: true, subtree: true });
    initFavoritesPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* ---- страница избранного ---- */

  function initFavoritesPage() {
    const grid = document.querySelector('[data-tipsy-favorites-grid]');
    if (!grid) return;
    const empty = document.querySelector('[data-tipsy-fav-empty]');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function showEmptyIfNeeded() {
      const isEmpty = grid.children.length === 0;
      if (empty) empty.hidden = !isEmpty;
      grid.hidden = isEmpty;
    }

    async function fetchCard(handle) {
      try {
        const res = await fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=tipsy-favorites-card');
        if (!res.ok) throw new Error(String(res.status));
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cell = doc.querySelector('#shopify-section-tipsy-favorites-card .content-item');
        return cell; // null, если товар скрыт/шаблон пуст
      } catch (e) {
        return null;
      }
    }

    async function load() {
      const handles = api.list();
      if (!handles.length) { showEmptyIfNeeded(); return; }
      grid.hidden = false;
      // до 6 запросов одновременно, порядок сохраняем
      const cells = new Array(handles.length).fill(null);
      let index = 0;
      async function worker() {
        while (index < handles.length) {
          const i = index++;
          cells[i] = await fetchCard(handles[i]);
        }
      }
      await Promise.all(Array.from({ length: Math.min(6, handles.length) }, worker));
      const gone = [];
      handles.forEach((handle, i) => {
        if (cells[i]) {
          cells[i].setAttribute('data-tipsy-fav-cell', handle);
          grid.appendChild(cells[i]);
        } else {
          gone.push(handle); // товар удалён/скрыт — выкидываем из списка
        }
      });
      if (gone.length) {
        const rest = api.list().filter((h) => gone.indexOf(h) === -1);
        write(rest);
      }
      showEmptyIfNeeded();
      paint();
    }

    // снятие сердечка на этой странице убирает карточку
    document.addEventListener('tipsy:favorites:changed', (e) => {
      const handles = (e.detail && e.detail.handles) || [];
      grid.querySelectorAll('[data-tipsy-fav-cell]').forEach((cell) => {
        if (handles.indexOf(cell.getAttribute('data-tipsy-fav-cell')) === -1) cell.remove();
      });
      showEmptyIfNeeded();
    });

    load();
  }
})();
